// src/theme/MuiLocaleProvider.tsx
//
// The UI library ships its own built-in texts in English (table pagination
// «Rows per page» / «1–10 of 20», «No options» in a combo box, «Close» on an
// alert...). The app theme is created once, without a language, so those
// texts stayed English on an otherwise Spanish screen. This provider adds the
// library's translation for the user's current language on top of the theme,
// for every page under the layout.
import React, { useCallback } from 'react';
import { ThemeProvider, createTheme, type Theme } from '@mui/material/styles';
import { enUS, esES } from '@mui/material/locale';
import { useLocaleState } from 'react-admin';

export const MuiLocaleProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [locale] = useLocaleState();
  const withLocale = useCallback((outer: Theme) => createTheme(outer, locale === 'en' ? enUS : esES), [locale]);
  return <ThemeProvider theme={withLocale}>{children}</ThemeProvider>;
};

export default MuiLocaleProvider;
